import { render, staticRenderFns } from "./NeedSidebar.vue?vue&type=template&id=36983163&scoped=true&"
import script from "./NeedSidebar.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedSidebar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36983163",
  null
  
)

export default component.exports